import { Button, Chip, Modal, Typography } from "@mui/material";

export const COLUMNSGESTIONESABIERTAS = [
    
    {
        header: 'Título',
        accessorKey: 'new_name',
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Tipo de Incidencia',
        accessorKey: 'new_tipodeincidencia',
        size: 50,
        minSize: 100,
        maxSize: 100,
        Cell: ({ cell }) => {
            switch (cell.getValue()) {
                case "Pregunta":
                    return <Chip label="Pregunta" sx={{ fontWeight: "bold" }} color="info" variant="outlined" />
                case "Problema":
                    return <Chip label="Problema" sx={{ fontWeight: "bold" }} color="error" variant="outlined" />
                case "Solicitud":
                    return <Chip label="Solicitud" sx={{ fontWeight: "bold" }} color="success" variant="outlined" />
            }
        },
    },
    {
        header: 'Tema',
        accessorKey: 'new_tema',
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: 'Origen',
        accessorKey: 'new_origen',
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: 'Alta de Incidente',
        accessorKey: 'new_altadeincidente',
        size: 50,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
]

export const COLUMNSGESTIONESRESUELTAS = [
    {
        header: 'Título',
        accessorKey: 'new_name',
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Tipo de Incidencia',
        accessorKey: 'new_tipodeincidencia',
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => {
            switch (cell.getValue()) {
                case "Pregunta":
                    return <Chip label="Pregunta" sx={{ fontWeight: "bold" }} color="info" variant="outlined" />
                case "Problema":
                    return <Chip label="Problema" sx={{ fontWeight: "bold" }} color="error" variant="outlined" />
                case "Solicitud":
                    return <Chip label="Solicitud" sx={{ fontWeight: "bold" }} color="success" variant="outlined" />
            }
        },
    },
    {
        header: 'Tema',
        accessorKey: 'new_tema',
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: 'Resolución',
        accessorKey: 'new_resolucion',
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
]